import { gql } from '@apollo/client';

/**
 * Query for cloud accounts by application
 */
export const GetCloudAccountsForApplication = gql`
  query CloudAccountsForApplication($applicationId: Int!) {
    resources {
      application(applicationId: $applicationId) {
        name
        cloudAccounts {
          id
          name
          platform
        }
      }
    }
  }
`;

/**
 * Query for applications for a cloud account
 */
export const GetApplicationsForCloudAccount = gql`
  query GetApplicationsForCloudAccount($cloudAccountIds: [String!]!) {
    devhub {
      connections {
        cloudAccounts(cloudAccountIds: $cloudAccountIds) {
          applications {
            applicationId
          }
        }
      }
    }
  }
`;

/**
 * Query for cloud accounts and roles by application
 */
export const GetCloudAccountsAndRolesForApplication = gql`
  query CloudAccountsAndRolesForApplication($applicationId: Int!) {
    resources {
      application(applicationId: $applicationId) {
        name
        status
        applicationId
        owner {
          displayName
        }
        cloudAccounts {
          id
          name
          platform
          status
          environment
          source
          applications {
            applicationId
            name
          }
        }
        roles {
          id
          name
          displayName
          responsibilities {
            responsibilityId
            roleName
            responsibleParty {
              ... on User {
                firstName
                lastName
                login
              }
              ... on Group {
                name
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * Query for and application for a given user
 */
export const GetCloudAccountsAndApplicationsForUser = gql`
  query CloudAccountsAndApplicationsForUser(
    $login: String!
    $filter: ResourceCatalogUserApplicationFilter
  ) {
    identity {
      user(login: $login) {
        resources {
          applicationsPaged(filter: $filter) {
            applications {
              name
              description
              applicationId
            }
          }
        }
        cloudAccounts {
          id
          name
          platform
          applications {
            applicationId
            name
          }
        }
      }
    }
  }
`;

/**
 * Query for cloud accounts for a user
 */
export const GetCloudAccountsForUser = gql`
  query CloudAccountsForUser($login: String!) {
    identity {
      user(login: $login) {
        cloudAccounts {
          id
          name
          platform
          applications {
            applicationId
            name
          }
        }
      }
    }
  }
`;

/**
 * Mutation to remove a cloud account from an application
 */
export const DeleteCloudAccountMutation = gql`
  mutation DeleteCloudAccountFromApp(
    $input: RemoveApplicationConnectionInput!
  ) {
    devhub {
      connections {
        cloudAccount {
          removeApplicationConnection(input: $input) {
            success
            message
          }
        }
      }
    }
  }
`;

/**
 * Mutation to create a cloud account relationship to an application
 */
export const CreateCloudAccountMutation = gql`
  mutation EstablishCloudAppConnection(
    $input: CreateApplicationConnectionInput!
  ) {
    devhub {
      connections {
        cloudAccount {
          addApplicationConnection(input: $input) {
            success
            message
          }
        }
      }
    }
  }
`;
